import React, { useContext } from "react";
import PropTypes from "prop-types";
import AppContext from "../../../AppContext";
import { ReactComponent as DefaultSvg } from "../../../assets/header/e-learning.svg";
import { langComponent } from "../../../constants";
import OutsideClickHandler from "react-outside-click-handler";

const Menu = ({ menus, onSelectMenu, style, onClose }) => {
  const { getLang } = useContext(AppContext);
  const Translation = getLang(langComponent.header);
  const handleOnClick = (menu) => {
    onSelectMenu(menu.path || menu);
  };

  return (
    <div className="header-menu" style={style}>
      <OutsideClickHandler onOutsideClick={() => onClose && onClose()}>
        <div style={{ style }}>
          {menus.map((menu) => {
            return (
              <div
                key={`menu-header-item-${menu.value}`}
                className="header-menu-link"
                onClick={() => handleOnClick(menu)}
              >
                <div className="header-menu-link__icon">
                  {menu.icon || <DefaultSvg />}
                </div>
                <div className="header-menu-link__name">
                  {Translation(menu.name)}
                  {menu.active ? (
                    ""
                  ) : (
                    <span className="urbaan-header__coming-soon">
                      Coming soon
                    </span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </OutsideClickHandler>
    </div>
  );
};

Menu.propTypes = {
  menus: PropTypes.array,
  onSelectMenu: PropTypes.func,
};

Menu.defaultProps = {
  menus: [],
  onSelectMenu: () => {},
};

export default Menu;
